import React from 'react';
import { RadioButtonGroup } from '@roger/ui-components';
import { Question } from '../types';

interface RadioQuestionProps {
  question: Question;
  value: string;
  onChange: (value: string) => void;
}

export const RadioQuestion: React.FC<RadioQuestionProps> = ({
  question,
  value,
  onChange,
}) => {
  if (!question.values) {
    return <div className='text-red-600'>Radio question missing values</div>;
  }

  const options = question.values.map(val => ({
    value: val,
    label: val,
  }));

  return (
    <div className='space-y-3'>
      <label className='text-sm font-medium text-gray-900 block'>
        {question.description}
        {question.qid && (
          <span className='ml-2 text-xs text-gray-500'>({question.qid})</span>
        )}
      </label>

      <RadioButtonGroup
        options={options}
        value={value || ''}
        onValueChange={onChange}
        orientation='vertical'
      />
    </div>
  );
};
